export const wrapper = {
	display: 'block',
};
